class RealLessonFaq extends HTMLElement {
  connectedCallback() {
    this.onBlockSelect = this.onBlockSelect.bind(this);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  onBlockSelect(event) {
    const blockId = event.detail?.blockId;
    if (!blockId) return;

    const row = Array.from(this.querySelectorAll('[data-real-lesson-faq-block-id]')).find(
      (item) => item.dataset.realLessonFaqBlockId === blockId
    );
    if (!(row instanceof HTMLDetailsElement)) return;

    row.open = true;
    window.requestAnimationFrame(() => {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
}

if (!customElements.get('real-lesson-faq')) {
  customElements.define('real-lesson-faq', RealLessonFaq);
}
